import React from 'react';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import type { ButtonProps } from '@construct-kit/core';
import {
  Text,
  typographyHelper,
  paletteHelper,
  spacingHelper,
  SearchMd,
  Button,
} from '@construct-kit/core';

interface SearchButtonProps extends ButtonProps {
  children?: string;
  onClick: () => void;
  isFromHomePage: boolean;
}

const StyledButton = styled(Button)`
  max-height: 3rem;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  justify-content: flex-start;
  padding: ${spacingHelper('extraSmall 0')};
  ${typographyHelper('body01')}
  color: ${paletteHelper('textSecondary')};
  :hover {
    background-color: ${paletteHelper('backgroundSecondaryBase')};
  }
  svg {
    display: inline-block;
    flex-shrink: 0;
    margin-left: ${spacingHelper('medium')};
    margin-right: ${spacingHelper('extraSmall')};
  }

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  ${({ theme }) => theme.layoutBreakpoints.large} {
    padding: ${spacingHelper('small 0')};
    border-radius: ${({ theme }) => theme.border.radius.medium};
    cursor: text;
    &:last-child {
      margin-right: ${spacingHelper('small')};
    }
    span {
      margin-left: ${spacingHelper('medium')};
    }
    svg {
      margin-right: 0;
    }
  }
`;

const SearchText = styled(Text).attrs({
  variant: 'body01',
})`
  color: ${paletteHelper('textPrimary')};
`;

export const LocationSearchButton = ({
  onClick,
  children,
  isFromHomePage,
}: SearchButtonProps): ReactElement => (
  <StyledButton
    icon={<SearchMd />}
    onClick={onClick}
    variant={isFromHomePage ? 'naked' : 'outline'}
    fullWidth
    aria-label="open location search"
  >
    <SearchText>
      {children || (isFromHomePage ? 'Where are you looking?' : 'Search suburb, postcode or state')}
    </SearchText>
  </StyledButton>
);
